/**
 * Where the results slides hand over to the consumer flow (the paywall slide's place). A consumer
 * walking the results journey after finishing their plan is updating it, so they continue at the first
 * consumer step, with every saved answer shown, rather than being sent straight back to Your Plan.
 * Everyone else goes to the flow entry, which starts them at that step too. The flow entry and the
 * overview's auto-resume still take a finished consumer to Your Plan.
 */
import { hasReachedFlowCompletion } from '../lib/flow-completion';
import { consumerEntryPath, consumerStepPath } from '../lib/paths';
import { FIRST_CONSUMER_STEP } from '../lib/steps';
import { useConsumerPlan } from './use-consumer-plan';

export function useConsumerFlowContinuation(clientId: string, { enabled }: { enabled: boolean }) {
  const { plan, applications, isLoading } = useConsumerPlan(clientId, { enabled });
  const isUpdating = hasReachedFlowCompletion(plan, applications);

  return {
    isLoading: enabled && isLoading,
    path: isUpdating
      ? consumerStepPath(clientId, FIRST_CONSUMER_STEP)
      : consumerEntryPath(clientId),
  };
}
